import { useEffect } from 'react';
import { ErrorShell } from './ErrorShell';

/** 403 — 권한 부족 시 사용. RequireAdmin / AuthGuard 등에서 navigate 로 진입 가능 */
export function ForbiddenPage() {
  useEffect(() => {
    document.title = '접근 권한이 없어요 · 시세공간';
  }, []);
  return (
    <ErrorShell
      code="403"
      title="접근 권한이 없어요"
      description="이 페이지를 볼 수 있는 권한이 없어요. 다른 계정으로 로그인했다면 로그아웃 후 다시 시도해주세요."
    />
  );
}
